import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import CustomDialog from "../../components/dialog";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import addLeaguesSchema from "../../schemas/addLeagues";
import { RHFTextField } from "../../components/hook-form";
import MyLeaguesTable from "./leaguesTable";
import LeagueInvitation from "./LeagueInvitation";
import addLeagues from "../../services/addLeagues";
import { toast } from "react-hot-toast";
import { useSearchParams } from "react-router-dom";

export default function MyLeagues() {
  const [createLeague, setCreateLeague] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [searchParams] = useSearchParams();

  const {
    register,
    getValues,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    ...methods
  } = useForm({
    resolver: yupResolver(addLeaguesSchema),
    defaultValues: {
      league_name: "",
      description: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      let res = await addLeagues(data.league_name, data.description);
      toast.success(res.message);
      setRefetch(!refetch);
      setLoading(false);
      setCreateLeague(false);
      methods.reset();
    } catch (err) {
      console.log("err === ", err);
      toast.error(err);
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex flex-row justify-content-between">
        <p className="heading-title">My Leagues</p>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          className="button-primary"
          onClick={() => setCreateLeague(true)}
        >
          League
        </Button>
      </div>

      <Box mt={1}>
        <MyLeaguesTable refetch={refetch} />
      </Box>

      {/* League Invitation Dialog */}
      {searchParams.get('league_id') && searchParams.get('token') && <LeagueInvitation />}

      {createLeague && (
        <FormProvider {...methods}>
          <form
            id="feedbackForm"
            className="feedback-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <CustomDialog
              open={createLeague}
              onClose={() => setCreateLeague(false)}
              title="Create League"
              buttonTxt="Create"
              fullWidth={true}
              handleClose={() => setCreateLeague(false)}
              handleSubmit={handleSubmit(onSubmit)}
              width={608}
              disableSubmit={loading}
              isLoading={loading}
            >
              <p className="label-text">Name</p>
              <RHFTextField name={"league_name"} />
              <p className="label-text mt-4">Description</p>
              <RHFTextField
                name={"description"}
                multiline
                rows={6}
                placeholder="Enter a detailed description of your league..."
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& textarea': {
                      fontSize: '0.9rem',
                      lineHeight: '1.5'
                    }
                  }
                }}
              />
            </CustomDialog>
          </form>
        </FormProvider>
      )}
    </div>
  );
}
